import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { SearchFilterAdvancedPage } from './search-filter-advanced.page';
import { BreedsService } from 'src/app/services/breeds/breeds.service';

const routes: Routes = [
  {
    path: '',
    component: SearchFilterAdvancedPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [SearchFilterAdvancedPage],
  providers: [
    BreedsService
  ]
})
export class SearchFilterAdvancedPageModule {}
